import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RoleGuard from 'utils/route-guard/RoleGuard';

const Channel = Loadable(lazy(() => import('views/Channel')));
const Log = Loadable(lazy(() => import('views/Log')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const User = Loadable(lazy(() => import('views/User')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const Revenue = Loadable(lazy(() => import('views/Revenue')));
const Hotels = Loadable(lazy(() => import('views/Hotels')));
const HotelWorkbench = Loadable(lazy(() => import('views/HotelWorkbench')));
const HotelRecharge = Loadable(lazy(() => import('views/HotelRecharge')));
const HotelMarketing = Loadable(lazy(() => import('views/HotelMarketing')));
const HotelNotifications = Loadable(lazy(() => import('views/HotelNotifications')));
const Agents = Loadable(lazy(() => import('views/Agents')));
const AITasks = Loadable(lazy(() => import('views/AITasks')));
const Rooms = Loadable(lazy(() => import('views/Rooms')));
const Payments = Loadable(lazy(() => import('views/Payments')));
const Diagnostic = Loadable(lazy(() => import('views/Diagnostic')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));
const PanelHome = Loadable(lazy(() => import('views/PanelHome')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));

const guard = (roles, element) => <RoleGuard roles={roles}>{element}</RoleGuard>;

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <PanelHome />
    },
    {
      path: 'dashboard',
      element: guard(['admin', 'agent'], <Dashboard />)
    },
    {
      path: 'channel',
      element: guard(['admin'], <Channel />)
    },
    {
      path: 'log',
      element: guard(['admin', 'agent'], <Log />)
    },
    {
      path: 'setting',
      element: guard(['admin'], <Setting />)
    },
    {
      path: 'token',
      element: guard(['admin'], <Token />)
    },
    {
      path: 'topup',
      element: <NotFoundView />
    },
    {
      path: 'redemption',
      element: <NotFoundView />
    },
    {
      path: 'user',
      element: guard(['admin'], <User />)
    },
    {
      path: 'profile',
      element: guard(['admin', 'agent', 'hotel'], <Profile />)
    },
    {
      path: 'revenue',
      element: guard(['admin', 'agent'], <Revenue />)
    },
    {
      path: 'hotels',
      element: guard(['admin', 'agent'], <Hotels />)
    },
    {
      path: 'hotel-workbench',
      element: guard(['hotel'], <HotelWorkbench />)
    },
    {
      path: 'hotel-recharge',
      element: guard(['hotel'], <HotelRecharge />)
    },
    {
      path: 'hotel-marketing',
      element: guard(['hotel'], <HotelMarketing />)
    },
    {
      path: 'hotel-notifications',
      element: guard(['hotel'], <HotelNotifications />)
    },
    {
      path: 'agents',
      element: guard(['admin', 'agent'], <Agents />)
    },
    {
      path: 'ai-tasks',
      element: guard(['admin'], <AITasks />)
    },
    {
      path: 'rooms',
      element: guard(['hotel'], <Rooms />)
    },
    {
      path: 'payments',
      element: guard(['admin', 'agent'], <Payments />)
    },
    {
      path: 'diagnostic',
      element: guard(['admin'], <Diagnostic />)
    },
    {
      path: '404',
      element: <NotFoundView />
    }
  ]
};

export default MainRoutes;
